import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";

Vue.config.productionTip = false;

var _hmt = _hmt || [];
window._hmt = _hmt;
if (process.env.NODE_ENV === "production") {
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?e0ca7026ef0967cca86541fde0a3d602";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
